import React, { useState, useEffect } from "react";
import { Button, Card, Form, Input, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { useAuth } from "../context/AuthContext";
import auth from "../../firebaseConfig";
const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const [email, setEmail] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const onFinish = async (values) => {
    if (loading) {
      return;
    }
    setError(null);
    setSuccessMessage("");
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, values.email);
      setSuccessMessage("Check your email for the reset password link!");
    } catch (err) {
      setError(err.message || "Failed to send reset email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card title="Reset Password" bordered={false} style={{ width: 300 }}>
        <Form name="reset_password" onFinish={onFinish}>
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Please input your email!" }]}
          >
            <Input
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                textTransform: "lowercase",
              }}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Send Password Reset Email
            </Button>
          </Form.Item>
        </Form>
        {error && <Typography.Text type="danger">{error}</Typography.Text>}
        {successMessage && (
          <Typography.Text type="success">{successMessage}</Typography.Text>
        )}
        <Button type="link" onClick={() => navigate("/login")}>
          Back to Log In
        </Button>
      </Card>
    </div>
  );
};

export default ResetPassword;
